import {
  App,
  Button,
  Col,
  Input,
  Pagination,
  Row,
  Spin,
  Table,
  Select,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import React, { useEffect, useState, useCallback, useRef } from "react";
import { GET_DOWNLOAD_REPORT, LIST_DOWNLOAD_QUIZ_TEST_REPORT } from "../../../apis/apis";
import CulsightPageLoader from "../../../components/CulsightPageLoader";
import { formatToIST } from "../../../../helper/CommonHelper";

function QuizDownload() {
  const { notification } = App.useApp();

  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [table_data, set_table_data] = useState([]);

  const [total_pages, set_total_pages] = useState(0);
  const [page_size, set_page_size] = useState(10);

  const [placeholder, set_placeholder] = useState("Search by name");


  const [current_page, set_current_page] = useState(
    Number(localStorage.getItem("quiz_download_page")) || 1
  );

  const [search_query_key, set_search_query_key] = useState(
    localStorage.getItem("quiz_download_search_key") || "title"
  );

  const [search_query_value, set_search_query_value] = useState(
    localStorage.getItem("quiz_download_search") || ""
  );

  const debounceRef = useRef(null);

  const LIST_API = async (page = current_page, key = search_query_key, value = search_query_value, size = page_size) => {
    set_pagination_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("page", page);
    FORM_DATA.append("per_page", size);

    if (key && value) FORM_DATA.append(key, value);

    try {
      const API_CALL = await LIST_DOWNLOAD_QUIZ_TEST_REPORT(FORM_DATA);

      if (API_CALL?.data?.status) {
        set_table_data(API_CALL?.data?.data);
        set_current_page(API_CALL?.data?.current_page);
        set_total_pages(API_CALL?.data?.total_pages);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
      set_pagination_loader(false);
    }
  };

  useEffect(() => {
    LIST_API(
      Number(localStorage.getItem("quiz_download_page")) || 1,
      localStorage.getItem("quiz_download_search_key") || "title",
      localStorage.getItem("quiz_download_search") || "",
      page_size
    );
  }, []);



  const handleInput = (e) => {
    const value = e.target.value;

    if (value && !search_query_value) {
      localStorage.setItem(
        "quiz_download_last_search_page",
        current_page
      );
    }

    set_search_query_value(value);

    localStorage.setItem(
      "quiz_download_search",
      value
    );

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {

      const pageToLoad = value
        ? 1
        : Number(
          localStorage.getItem(
            "quiz_download_last_search_page"
          )
        ) || 1;

      set_current_page(pageToLoad);

      LIST_API(
        pageToLoad,
        search_query_key,
        value,
        page_size
      );

    }, 500);
  };

  const pagination_on_change = (page, size) => {

    localStorage.setItem(
      "quiz_download_page",
      page
    );

    set_page_size(size);

    LIST_API(
      page,
      search_query_key,
      search_query_value,
      size
    );
  };

  const DOWNLOAD_ACTION = async (id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("id", id);
      const API_CALL = await GET_DOWNLOAD_REPORT(FORM_DATA);
      if (API_CALL?.data?.status) {
        window.location = API_CALL?.data?.url
        notification.success({
          message: "Download Started",
          description: "file downloaded",
        });
      } else {
        notification.error({
          message: "Failed",
          description: API_CALL?.data?.error || "Download failed",
        });
      }
    } catch (err) {
      notification.error({
        message: "Server Error",
        description: "Unable to download report",
      });
    }
  };

  const selectBefore = (
    <Select
      defaultValue="Name"
      onChange={(value) => {

        const key =
          value === "Name"
            ? "title"
            : "email";

        set_search_query_key(key);

        localStorage.setItem(
          "quiz_download_search_key",
          key
        );

        if (value === "Name") {
          set_placeholder("Search by name");
        }

        if (value === "Email") {
          set_placeholder("Search by email");
        }

        LIST_API(
          current_page,
          key,
          search_query_value,
          page_size
        );
      }}
    >
      <Select.Option value="Name">
        Name
      </Select.Option>

      <Select.Option value="Email">
        Email
      </Select.Option>
    </Select>
  );

  const columns = [
    {
      title: "Title",
      dataIndex: "report_view",
      render: (text, record) => {
        try {
          const rv = record.report_view;
          const titleMatch = rv.match(/'title':\s*'([^']+)'/);
          const nameMatch = rv.match(/'name':\s*'([^']+)'/);
          return <span>{titleMatch?.[1] || nameMatch?.[1] || "N/A"}</span>;
        } catch {
          return <span>N/A</span>;
        }
      },
    },
    {
      title: "Email",
      dataIndex: "report_view",
      render: (text, record) => {
        try {
          const rv = record.report_view;
          const emailMatch = rv.match(/'email':\s*'([^']+)'/);
          return <span>{emailMatch?.[1] || "N/A"}</span>;
        } catch {
          return <span>N/A</span>;
        }
      },
    },
    // {
    //   title: "Report Type",
    //   dataIndex: "report_type",
    //   render: (text) => {
    //     const mapping = { quiz_report: "Quiz Report" };
    //     return <span>{mapping[text] || "N/A"}</span>;
    //   },
    // },
    {
      title: "Download On",
      dataIndex: "created_at",
      render: (text, record) => <span>{formatToIST(record?.created_at)}</span>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          onClick={() => DOWNLOAD_ACTION(record.id)}
          type="primary"
          size="small"
          style={{ color: "white", backgroundColor: "#1fa7a1" }}
        >
          Download
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Row gutter={[16, 16]} align="middle">
        <Col span={24}>
          <Input
            addonBefore={selectBefore}
            placeholder={placeholder}
            size="large"
            value={search_query_value}
            onChange={handleInput}
          />
        </Col>
      </Row>

      {loader ? (
        <CulsightPageLoader />
      ) : pagination_loader ? (
        <div style={{ textAlign: "center", padding: "60px" }}>
          <Spin indicator={<LoadingOutlined spin />} size="large" />
        </div>
      ) : (
        <>
          <Table
            columns={columns}
            dataSource={table_data}
            pagination={false}
            style={{ marginTop: "15px" }}
            rowKey="id"
          />

          {total_pages > 0 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "15px",
                marginTop: "20px",
              }}
            >
              <Pagination
                current={current_page}
                onChange={pagination_on_change}
                total={total_pages * page_size}
                pageSize={page_size}
                showSizeChanger={false}
              />
              <Select
                value={page_size}
                onChange={(value) => {

                  localStorage.setItem(
                    "quiz_download_page",
                    1
                  );

                  set_page_size(value);

                  pagination_on_change(1, value);
                }}
                style={{ width: 120 }}
                options={[
                  { value: 10, label: "10 / page" },
                  { value: 20, label: "20 / page" },
                  { value: 50, label: "50 / page" },
                  { value: 100, label: "100 / page" },
                ]}
              />
            </div>
          ) : (
            <div style={{ textAlign: "center", color: "red" }}>
              <h2>No Data Found</h2>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default QuizDownload;
